import React, { useState } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';

function APIEightForm() {
  const [inputs, setInputs] = useState({
    brand_name: '',
    celeb_name: '',
    context: '',
    idea: ''
  });
  const [threadId, setThreadId] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isInitialRequest, setIsInitialRequest] = useState(true);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    try {
      const res = await axios.post(
        'https://ai-api.fuselight.com/create_launchpad',
        {
          brand_name: inputs.brand_name,
          ...(inputs.celeb_name && { celeb_name: inputs.celeb_name }),
          ...(inputs.context && { context: inputs.context }),
          ...(inputs.idea && { idea: inputs.idea })
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      setThreadId(res.data.thread_id);
      const response = res.data.response;
      const chatMessages = [
        { sender: 'bot', text: response.opening_text },
        ...response.idea.map((idea) => ({
          sender: 'bot',
          text: `**${idea.title}**\n\n${idea.desc}`
        })),
        { sender: 'bot', text: response.closing_text }
      ];
      setChatHistory(chatMessages);
      setIsInitialRequest(false);
    } catch (error) {
      console.error('Error creating launchpad:', error);
      setErrorMessage('Failed to create launchpad. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendMessage = async (event) => {
    event.preventDefault();
    if (!threadId) {
      setErrorMessage('Thread not created yet. Please submit initial details first.');
      return;
    }
    setIsLoading(true);
    setErrorMessage('');
    try {
      const res = await axios.post(
        'https://ai-api.fuselight.com/message_launchpad',
        {
          thread_id: threadId,
          text: message
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      const response = res.data.response;
      const chatMessages = [
        { sender: 'user', text: message },
        { sender: 'bot', text: response.opening_text },
        ...(response.idea ? response.idea.map((idea) => ({
          sender: 'bot',
          text: `**${idea.title}**\n\n${idea.desc}`
        })) : []),
        { sender: 'bot', text: response.closing_text }
      ];
      setChatHistory([...chatHistory, ...chatMessages]);
      setMessage('');
    } catch (error) {
      console.error('Error sending message:', error);
      setErrorMessage('Failed to send message. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    setInputs({
      brand_name: '',
      celeb_name: '',
      context: '',
      idea: ''
    });
    setThreadId('');
    setChatHistory([]);
    setMessage('');
    setIsInitialRequest(true);
  };

  return (
    <div className="launchpad-container">
      {isInitialRequest ? (
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <input
              type="text"
              name="brand_name"
              value={inputs.brand_name}
              onChange={handleChange}
              placeholder="Brand Name"
              required
            />
            <input
              type="text"
              name="celeb_name"
              value={inputs.celeb_name}
              onChange={handleChange}
              placeholder="Celebrity Name"
            />
          </div>
          <div className="form-row">
            <textarea
              name="context"
              value={inputs.context}
              onChange={handleChange}
              placeholder="Context"
            />
            <textarea
              name="idea"
              value={inputs.idea}
              onChange={handleChange}
              placeholder="Idea"
            />
          </div>
          <div className="form-row">
            <button type="submit">Submit</button>
          </div>
        </form>
      ) : (
        <>
          <div className="chat-history">
            {chatHistory.map((chat, index) => (
              <div key={index} className={`chat-message ${chat.sender}`}>
                <ReactMarkdown>{chat.text}</ReactMarkdown>
              </div>
            ))}
            {isLoading && <div className="loading-message">Loading...</div>}
          </div>
          <form onSubmit={handleSendMessage} className="message-form">
            <div className="form-row">
              <textarea
                value={message}
                onChange={handleMessageChange}
                placeholder="Type your message"
                required
              />
            </div>
            <div className="form-row">
              <button type="submit">Send</button>
              <button type="button" onClick={handleReset}>New Submission</button>
            </div>
          </form>
        </>
      )}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
}

export default APIEightForm;

